export const formatPercentOnEdit = (value: string = "") => {
  let numberValue = parseInt(value.replaceAll(/[^0-9]*/g, ""), 10);
  if (isNaN(numberValue)) {
    return "";
  }

  if (numberValue > 100) {
    numberValue = 100;
  } else if (numberValue < 0) {
    numberValue = 0;
  }

  return String(numberValue);
};

export const formatPercentOnBlur = (value: string = "") =>
  value === "%" ? "" : value === "" ? "" : `${value.replace("%", "")}%`;

export const formatMileagePercentOnEdit = (value = "") => {
  const cleared = value.replaceAll(/[^0-9.]*/g, "");
  const numberValue = parseFloat(cleared);
  if (isNaN(numberValue)) {
    return "";
  }

  if (numberValue > 100) {
    return "100";
  } else if (numberValue < 0) {
    return "0";
  }

  return cleared;
};
